/**
 * The presets window: reusable node templates, docked in the layout. Most of the time they
 * live in the drawer instead (`app/PresetDrawer.tsx`, Ctrl+Space); "Dock in layout" there opens
 * this window, and "Back to the drawer" here closes it.
 *
 * - Click a card to add its node next to the selected node (or in the middle of the view).
 * - Drag a card onto the graph to add the node where you drop it, or onto a folder of the
 *   tree to move it there (same library) or copy it (another library).
 * - The libraries: built-in (read-only), this computer's, and in a space yours and your
 *   team's (`state/presets.ts`), each arranged in folders (right-click a folder).
 *
 * Files: `PresetBrowser` (tree + gallery, or the form), `FolderTree`, `folders.ts` (naming,
 * folder menus), `PresetGallery` (tiles and cards), `PresetCard`, `PresetForm`,
 * `placement.ts` (where a new node appears, and dragging a card).
 *
 * Adding a preset is **one** edit in the core (node + auto-links), so one undo removes it.
 */
import type { JSX } from "solid-js";
import { useApp } from "../../app/context";
import { PresetBrowser } from "./PresetBrowser";

/** The presets window. */
export function PresetsWindow(): JSX.Element {
  const { presets, wm } = useApp();
  return (
    <PresetBrowser
      tools={
        <button
          type="button"
          class="mini"
          id="preset-undock"
          title="Close this window; the presets stay in the drawer (Ctrl+Space)"
          onClick={() => {
            wm.close("presets");
            presets.setDrawer(true);
          }}
        >
          Back to the drawer
        </button>
      }
    />
  );
}
